import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { serchSelect, tabulation, gmToolNewPage, gmTool } from "@/mixins/index";
import { newServerRoleProductAmountDetail, newServerRoleProductAmountDetailCurrency } from "@/api/dataAll/userSegmentationGrowth";
import { serverList } from "@/api/gmtool/packageCode";
import { serverList as hdServerList } from "@/api/gmtool/packageCode";
import { serverList as yjServerList } from "@/api/gmToolNew/gmToolNew";
export default {
  name: "levelPaymentAmount",
  mixins: [serchSelect, tabulation, gmToolNewPage, gmTool],
  data: function data() {
    return {
      tableData: [],
      paramsData: {
        penetration: 3
      },
      tableList: [],
      serverList: [],
      levelList: [],
      exportdataDealoading: false
    };
  },
  computed: _objectSpread({}, mapState("d2admin", {
    severlist: function severlist(state) {
      return state.user.GMauthority;
    }
  })),
  created: function created() {
    this.searchData.env_id = this.szgmEnv.length ? this.szgmEnv[0].id : '';

    if (this.rawData.game_mark.indexOf('yjfm') == -1) {
      this.getServer();
    }
  },
  methods: {
    levelChange: function levelChange(e) {
      if (!e) {
        this.paramsData.recharge_levels = '';
      }
    },
    getServer: function getServer() {
      var _this = this;

      this.paramsData.server_id = '';
      serverList({
        is_prod: this.paramsData.is_prod,
        page_size: ''
      }).then(function (res) {
        if (res.status == 200) {
          _this.serverList = res.data;
        }
      });
    },
    searchClick: function searchClick() {
      var _this2 = this;

      this.tableList = [];
      this.tableData = [];

      if (this.value2.length > 0) {
        this.searchData.starttime = this.value2[0];
        this.searchData.endtime = this.value2[1];
      }

      if (this.levelItem == '1' && !this.paramsData.recharge_levels) {
        this.$message.error(this.$t('pleaseInputLevel'));
        return;
      }

      if (/，/.test(this.paramsData.recharge_levels)) {
        this.$message.error(this.$t('pleaseInputEnglishComma'));
        return;
      }

      this.reqLoading = true;
      var params = {
        game_id: this.searchData.game_id,
        special_product_id: this.searchData.special_product_id,
        starttime: this.searchData.starttime,
        endtime: this.searchData.endtime,
        server_id: this.paramsData.server_id,
        recharge_levels: this.paramsData.recharge_levels,
        character_id: this.paramsData.character_id // penetration: this.paramsData.penetration,

      }; //判断是否有货币

      var searchCurrency = this.$store.state.d2admin.serchSelect.searchCurrency;
      var reqFn = searchCurrency.length ? newServerRoleProductAmountDetailCurrency : newServerRoleProductAmountDetail;
      reqFn(params).then(function (res) {
        if (res.code == 200) {
          if (!res.data) {
            return;
          }

          var data = res.data;
          var level_map = res.tier_config;
          var statusArr = [];
          var tableItem = []; //处理表格数据

          _this2.tableList = [];

          for (var m in level_map) {
            tableItem.push({});
          }

          for (var date in data) {
            _this2.tableList.push({
              label: date,
              prop: date,
              list: [{
                label: _this2.$t('payPeopleCount'),
                prop: date + "user_count"
              }, {
                label: _this2.$t('avgAmount'),
                prop: date + "avg_amount"
              }, {
                label: _this2.$t('maxAmount'),
                prop: date + "max_amount"
              }, {
                label: _this2.$t('minAmount'),
                prop: date + "min_amount"
              }]
            });
          }

          var levels = Object.keys(level_map);

          for (var i = 0; i < levels.length; i++) {
            var level = levels[i];
            var rowData = {};

            for (var _date in data) {
              if (data[_date][level]) {
                rowData[_date + "avg_amount"] = data[_date][level]["avg_amount"];
                rowData[_date + "max_amount"] = data[_date][level]["max_amount"];
                rowData[_date + "min_amount"] = data[_date][level]["min_amount"];
                rowData[_date + "user_count"] = data[_date][level]["user_count"];
              }
            }

            _this2.tableData.push(rowData);
          }

          _this2.tableList.unshift({
            label: '',
            list: [{
              label: _this2.$t('payAmount'),
              prop: 'level_amount'
            }]
          });

          tableItem.forEach(function (items, idx) {
            _this2.tableData[idx]["level_amount"] = level_map["level_".concat(idx + 1)]["range"];
          });
        }
      }).finally(function () {
        _this2.reqLoading = false;
      });
    },
    exportdata: function exportdata() {
      this.exportdataDealoading = true;
      var columns = [];
      var d = {};
      this.tableList.forEach(function (item, index) {
        item.list.forEach(function (items, indexs) {
          columns.push({
            label: indexs == 0 ? item.label : '',
            prop: items.prop
          });
          d[items.prop] = items.label;
        });
      });
      var data = JSON.parse(JSON.stringify(this.tableData));
      data.unshift(d);
      this.$export.excel({
        columns: columns,
        data: data,
        title: this.$route.meta.title
      });
      this.exportdataDealoading = false;
    }
  }
};